import { connect } from 'react-redux';
import MicCard from './MicCard';
import selectors from '../../../../rootSelectors';

const mapStateToProps = state => ({
    recordingStream: selectors.getRecordingStream(state),
    isRecordingInProgress: selectors.getIsRecordingInProgress(state),
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    recordedResult: selectors.getRecordedResult(state),
});

export default connect(mapStateToProps, null)(MicCard);
